import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { NAV_DATA } from 'constants/navConstants';
import SecondaryNavV2 from 'components/common/header/SecondaryNavV2';

import { getThemesV2, unMountComponent } from '../../../actions/website/ThemeActions';
import Themes from './Themes';
import CardsModalRoot from '../../../cards/components/common/CardsModalRoot';
import '../../../stylesheets/pages/Themes.less';

class ThemesContainer extends Component {
  componentDidMount() {
    const { loadThemes } = this.props;
    loadThemes(0);
  }

  componentWillUnmount() {
    const { unMountThemes } = this.props;
    unMountThemes();
  }

  render() {
    return (
      <Fragment>
        <SecondaryNavV2 activeLinkId={NAV_DATA.SECONDARY.WEBSITE.DESIGNS} />
        <Themes />
        <CardsModalRoot />
      </Fragment>
    );
  }
}

ThemesContainer.propTypes = {
  loadThemes: PropTypes.func.isRequired,
  unMountThemes: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  loadThemes: offset => {
    dispatch(getThemesV2(offset));
  },
  unMountThemes: () => dispatch(unMountComponent()),
});

export default connect(null, mapDispatchToProps)(ThemesContainer);



// WEBPACK FOOTER //
// ./src/components/manage/website/ThemesContainer.jsx